import styled from 'styled-components'

const StyledOverview = styled.div`
  .heading.overview {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    margin-top: -10px;

    .date-options {
      display: flex;
      align-items: center;

      .joined-label {
        margin-right: 20px;
        font-size: 14px;
        font-weight: 600;
        display: none;
        color: ${({ theme }) => theme.colors.gray[500]};
      }

      .dropdown {
        max-width: 200px;
      }
    }
  }

  .overview-metrics {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    grid-gap: 20px;

    .overview-metric {
      background-color: ${({ theme }) => theme.colors.gray[50]};
      border-radius: 6px;
      padding: 20px 0;
      text-align: center;
      display: grid;
      grid-gap: 8px;

      .metric-label {
        font-size: 14px;
        color: ${({ theme }) => theme.colors.gray[500]};
        font-weight: 600;
      }

      .metric-value {
        font-size: 32px;
        font-weight: 300;
        font-family: ${({ theme }) => theme.fonts.lexend};
        color: ${({ theme }) => theme.colors.gray[700]};
      }

      &:first-child {
        background-color: ${({ theme }) => theme.colors.green[50]};

        .metric-label,
        .metric-value {
          color: ${({ theme }) => theme.colors.green[600]};
        }
      }

      &:nth-of-type(1) {
        grid-column: 1 / 3;
        grid-row: 1;
      }

      &:nth-of-type(2) {
        grid-column: 1 / 2;
        grid-row: 2;
      }

      &:nth-of-type(3) {
        grid-column: 2 / 2;
        grid-row: 2;
      }

      &:nth-of-type(4) {
        grid-column: 1 / 3;
        grid-row: 3;
      }
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.s}px) {
    .heading.overview {
      .date-options {
        .joined-label {
          display: block;
        }
      }
    }

    .overview-metrics {
      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));

      .overview-metric {
        &:nth-of-type(1),
        &:nth-of-type(2),
        &:nth-of-type(3),
        &:nth-of-type(4) {
          grid-column: unset;
          grid-row: unset;
        }
      }
    }
  }
`

export default StyledOverview
